// extracted by mini-css-extract-plugin
export var lg = "_d8-7";
export var md = "_d8-6";
export var placeholderContainer = "_d8-1";
export var placeholderIcon = "_d8-2";
export var productImage = "_d8-0";
export var sm = "_d8-5";
export var xl = "_d8-8";
export var xs = "_d8-4";
export var xxs = "_d8-3";